import React from 'react'
import { ReactComponent as ArrowUpIcon } from 'bootstrap-icons/icons/arrow-up-circle-fill.svg'
import { ReactComponent as HelpIcon } from 'bootstrap-icons/icons/question-circle-fill.svg'
import ControlSaveComponent from '../save/ControlSave'
import styles from './Navbar.module.scss'
import { Visibility } from '../../common/Enums'

/**
 * Props required to render the navbar component
 */
export interface INavbarProps {
    onCreateBoard: () => void
    onInfoVisible: () => void
    onInfoHidden: () => void
    isInfoVisible: Visibility
}

/**
 * Renders the Navbar component
 * @param {INavbarProps} props for rendering the navbar
 * @returns {JSX.Element} Navbar react component
 */
function NavbarComponent(props: INavbarProps) {
    function isInfoVisible(): boolean {
        return props.isInfoVisible === Visibility.Visible
    }

    return (
        <>
            <nav className={`navbar ${styles.gradient}`}>
                <span className="navbar-brand text-secondary">
                    React Kanban Boards
                </span>
                <div className="flex-grow-1 form-inline">
                    <button
                        type="button"
                        className="btn btn-outline-secondary mr-2"
                        onClick={props.onCreateBoard}>
                        Add Board
                    </button>
                    <ControlSaveComponent />
                </div>

                <form className="form-inline">
                    <button
                        type="button"
                        className="btn text-secondary p-0 mr-1"
                        onClick={() =>
                            isInfoVisible()
                                ? props.onInfoHidden()
                                : props.onInfoVisible()
                        }
                        aria-label={`${
                            isInfoVisible() ? 'Hide' : 'Show'
                        } project information`}>
                        {isInfoVisible() ? (
                            <ArrowUpIcon className={styles.icon} />
                        ) : (
                            <HelpIcon className={styles.icon} />
                        )}
                    </button>
                </form>
            </nav>
            <div
                aria-label="application information"
                className={`p-3 ${
                    isInfoVisible() ? 'collapse.show' : 'collapse'
                }`}>
                <p>
                    Created by Tim Kilminster as a demonstration project
                    showcasing use of React.
                </p>
                <p>
                    This simple Kanban board project has been created using
                    React and Typescript. Boards, swimlanes and tickets are
                    stored in local browser storage (not cookies).
                </p>
                <p>
                    You can collapse this pannel by clicking on he arrow on the
                    right hand side of the header and expand it by clicking
                    again.
                </p>
            </div>
        </>
    )
}

export default NavbarComponent
